import axios from 'axios'
import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

export const GetUserAdmin = {
    mixins: [GetAxiosAuthConfig],
    
    data() {
        return {
            is_user_admin: false,
            is_user_loggedin: false,
        }
    },
    created() {
        this.GetIsUserAdmin()
        this.GetIsUserLoggedIn()
    },
    methods: {
        GetIsUserAdmin() {
            // Checks if user 'is_staff' on the admin backend
            let rest_url = window.location.origin + '/api/myuser/'
            
            axios.get(rest_url, axios_auth_config).then(response => {
                this.is_user_admin = response.data.is_staff
            })
            .catch(function(error) {
                console.log('Can not check if user is admin (not authed).')
            }
        )
        },
        GetIsUserLoggedIn() {
            let rest_url = window.location.origin + '/api/myuser/'
            
            axios.get(rest_url, axios_auth_config).then(response => {
                this.is_user_loggedin = true
            })
            .catch(function(error) {
                    console.log('User is not authed.')

                    // always remove localstorage if not authed? kicks them out
                    localStorage.removeItem('den_vueauth_token')
                    
                    // also delete old ones
                    localStorage.removeItem('vue-authenticate.vueauth_token')
                    localStorage.removeItem('vue-authenticate.null_state')

                    localStorage.removeItem('den_loggedin')
                    localStorage.removeItem('den_user')
                    localStorage.removeItem('den_user_email')
                    localStorage.removeItem('den_user_slack_id')
                    localStorage.removeItem('den_user_slack_username')

                    // refreshes window properly instead of using the router
                    // this breaks a route where user doesnt need to be authed! so dont always do it
                    // window.location = "/"
                }
            )
        }
    },
}
